// extracted by mini-css-extract-plugin
export default {"arrows":"Arrow_arrows__5DZBO","scroll":"Arrow_scroll__kDHuJ","scroll-down":"Arrow_scroll-down__-71zv","arrow":"Arrow_arrow__q2Ku-","color-change":"Arrow_color-change__C7mPD"};